"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
function makeLines(mainSeries, shadowSeries) {
    var answer = [];
    for (var _i = 0, mainSeries_1 = mainSeries; _i < mainSeries_1.length; _i++) {
        var m = mainSeries_1[_i];
        for (var _a = 0, shadowSeries_1 = shadowSeries; _a < shadowSeries_1.length; _a++) {
            var s = shadowSeries_1[_a];
            if (m.name === s.name) {
                answer.push({
                    showInLegend: false,
                    type: 'line', color: '#f9a65a', zIndex: 4,
                    marker: {
                        enabled: false,
                        states: {
                            hover: {
                                enabled: false
                            }
                        }
                    },
                    linkedTo: ':previous',
                    data: [{
                            x: m.x,
                            y: m.y
                        }, {
                            x: s.x,
                            y: s.y
                        }
                    ]
                });
            }
        }
    }
    return answer;
}
function getChartRange(series) {
    var xMin = Number.MAX_SAFE_INTEGER;
    var xMax = Number.MIN_SAFE_INTEGER;
    series.forEach(function (s) {
        if (s && s.length > 0) {
            s.forEach(function (item) {
                xMin = Math.min(item.x, item.y, xMin);
                xMax = Math.max(item.x, item.y, xMax);
            });
        }
    });
    if (xMin > xMax) {
        xMin = xMax = 0;
    }
    var xFix = (xMax - xMin) / 10.0;
    return [xMin - xFix, xMax + xFix];
}
function generateSeries(dataRows, legends, zindex) {
    if (zindex === void 0) { zindex = 6; }
    var series = [];
    var _loop_1 = function (legend) {
        var tagKey = legend['tag'];
        var tagColor = legend['color'];
        var seriesData = dataRows.filter(function (item) { return item.colorTag === tagKey; });
        if (seriesData.length > 0) {
            series.push({
                'name': tagKey,
                'color': tagColor,
                'zIndex': zindex,
                'data': seriesData
            });
        }
    };
    for (var _i = 0, legends_1 = legends; _i < legends_1.length; _i++) {
        var legend = legends_1[_i];
        _loop_1(legend);
    }
    return series;
}
/**
 * Transform leaf node data for table display
 * Creates individual rows for each data point instead of showing arrays
 */
function transformLeafDataForTable(graph) {
    if (!graph.mainRows || graph.mainRows.length === 0) {
        return graph;
    }
    var xKey = graph.xKey || (graph.headerMap && graph.headerMap.length > 0 ? graph.headerMap[0].key : 'GrossRevenue');
    var yKey = graph.yKey || (graph.headerMap && graph.headerMap.length > 0 ? graph.headerMap[1].key : 'OperatingProfit');
    // Check if this is leaf node data (has arrays) for main rows
    var firstRow = graph.mainRows[0];
    var isMainLeafNode = firstRow[xKey] && Array.isArray(firstRow[xKey]) &&
        firstRow[yKey] && Array.isArray(firstRow[yKey]);
    // Check if sibling data has leaf nodes (arrays)
    var hasSiblingLeafNodes = graph.siblingRows && graph.siblingRows.length > 0 &&
        graph.siblingRows[0][xKey] && Array.isArray(graph.siblingRows[0][xKey]) &&
        graph.siblingRows[0][yKey] && Array.isArray(graph.siblingRows[0][yKey]);
    if (!isMainLeafNode && !hasSiblingLeafNodes) {
        return __assign({}, graph, { isLeafNodeData: false, useIndexWiseJoining: false }); // Return with flags set for parent nodes
    }
    // Transform main data for table display
    var transformedMainRows = [];
    if (isMainLeafNode) {
        graph.mainRows.forEach(function (row) {
            var _a;
            if (row[xKey] && Array.isArray(row[xKey]) &&
                row[yKey] && Array.isArray(row[yKey])) {
                var minLength = Math.min(row[xKey].length, row[yKey].length);
                for (var i = 0; i < minLength; i++) {
                    var x = row[xKey][i];
                    var y = row[yKey][i];
                    // Include all points, even those with 0 values
                    transformedMainRows.push((_a = {
                            name: "" + row.name,
                            tags: row.tags,
                            color: row.color,
                            colorTag: row.colorTag,
                            groups: row.groups
                        },
                        _a[xKey] = x,
                        _a[yKey] = y,
                        _a));
                }
            }
        });
    }
    else {
        transformedMainRows = graph.mainRows;
    }
    // Transform sibling data for table display
    var transformedSiblingRows = [];
    if (hasSiblingLeafNodes) {
        graph.siblingRows.forEach(function (row) {
            var _a;
            if (row[xKey] && Array.isArray(row[xKey]) &&
                row[yKey] && Array.isArray(row[yKey])) {
                var minLength = Math.min(row[xKey].length, row[yKey].length);
                for (var i = 0; i < minLength; i++) {
                    var x = row[xKey][i];
                    var y = row[yKey][i];
                    // Include all points, even those with 0 values
                    transformedSiblingRows.push((_a = {
                            name: "" + row.name,
                            tags: row.tags,
                            color: row.color,
                            colorTag: row.colorTag,
                            groups: row.groups
                        },
                        _a[xKey] = x,
                        _a[yKey] = y,
                        _a));
                }
            }
        });
    }
    else if (graph.siblingRows) {
        transformedSiblingRows = graph.siblingRows;
    }
    // Create a new graph object with transformed data
    return __assign({}, graph, { mainRows: transformedMainRows, siblingRows: transformedSiblingRows, 
        // Flag to indicate this data has been transformed from leaf nodes (arrays) to individual data points
        isLeafNodeData: isMainLeafNode || hasSiblingLeafNodes, 
        // Flag to indicate that leaf node data should be joined index-wise instead of by name
        useIndexWiseJoining: isMainLeafNode && hasSiblingLeafNodes, 
        // Don't show totals for leaf node data points
        shouldTotal: false });
}
exports.transformLeafDataForTable = transformLeafDataForTable;
function getChartOptions(graph, options) {
    var _a;
    var currentNode = options.currentNode, chartTitle = options.chartTitle, _b = options.legends, legends = _b.legends, siblingLegends = _b.siblingLegends, settings = options.settings, timestamp = options.timestamp;
    var nodeName = currentNode.name;
    // Process leaf node data if needed (arrays of values)
    var mainSeriesData = processDataRows(graph.mainRows, graph);
    mainSeriesData = mainSeriesData.sort(function (a, b) { return a.x - b.x; });
    // Process sibling data through processDataRows to handle leaf nodes (arrays)
    var siblingSeriesData = processDataRows(graph.siblingRows || [], graph);
    siblingSeriesData = siblingSeriesData.sort(function (a, b) { return a.x - b.x; });
    var series = generateSeries(mainSeriesData, legends, 6);
    var drilldown = graph.mainDrillDown;
    var lines = [];
    if (siblingSeriesData.length > 0) {
        lines = makeLines(mainSeriesData, siblingSeriesData);
        var siblingSeries = generateSeries(siblingSeriesData, siblingLegends, 5);
        series = series.concat(siblingSeries, lines);
        drilldown = drilldown.concat(graph.siblingDrillDown);
    }
    var drilldownSeries = drilldown.reduce(function (se, s) { return se.concat(s.data); }, []);
    var xMin = null, xMax = null;
    if (graph.sameScale) {
        _a = getChartRange([mainSeriesData, siblingSeriesData, drilldownSeries]), xMin = _a[0], xMax = _a[1];
    }
    return {
        chart: {
            renderTo: 'chartContainer',
            height: 560,
            width: 580,
            type: 'scatter',
            zoomType: 'xy',
            marginRight: 50
        },
        credits: {
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                if (this.point.name) {
                    return (this.point.name !== this.series.name ? "<b>" + this.point.name + "</b> <i>(" + this.series.name + ")</i><br />" : "<b>" + this.point.name + "</b><br />") +
                        (graph.yTitle + ": <b>" + this.point.y.toFixed(settings.decimals) + "</b><br />") +
                        (graph.xTitle + ": <b>" + this.point.x.toFixed(settings.decimals) + "</b>");
                }
                else {
                    return false;
                }
            },
            crosshairs: [true, true]
        },
        xAxis: {
            tickPixelInterval: 100,
            min: xMin,
            max: xMax,
            title: {
                enabled: true,
                text: graph.xTitle
            },
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true,
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 1
                }]
        },
        yAxis: {
            tickPixelInterval: 100,
            min: xMin,
            max: xMax,
            title: {
                enabled: true,
                text: graph.yTitle
            },
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 1
                }]
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            },
            scatter: {
                dataLabels: {
                    enabled: settings.showLabel,
                    style: {
                        fontWeight: 'thin'
                    },
                    formatter: function () {
                        if (!this.series.name || this.series.name.indexOf(":") !== -1) {
                            this.series.name = nodeName;
                        }
                        return this.point.name.slice(0, settings.charsInLabel);
                    }
                },
                marker: {
                    radius: 5,
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                }
            }
        },
        series: series,
        drilldown: {
            activeAxisLabelStyle: {
                textDecoration: 'none',
                cursor: 'default',
                color: '#666666',
                'font-weight': 'normal',
                'pointer-events': 'none'
            },
            series: drilldown
        },
        // Add the transformed data for table use
        transformedTableData: transformLeafDataForTable(graph)
    };
}
exports.getChartOptions = getChartOptions;
/**
 * Process data rows to handle both parent nodes (single x,y) and leaf nodes (arrays of data)
 */
function processDataRows(dataRows, graph) {
    if (!dataRows || !dataRows.length)
        return [];
    // Get the keys from the graph object
    var xKey = graph.xKey || (graph.headerMap && graph.headerMap.length > 0 ? graph.headerMap[0].key : 'GrossRevenue');
    var yKey = graph.yKey || (graph.headerMap && graph.headerMap.length > 0 ? graph.headerMap[1].key : 'OperatingProfit');
    return dataRows.map(function (row) {
        // Check if this is a leaf node with array data for the specific xKey and yKey
        if (row[xKey] && Array.isArray(row[xKey]) &&
            row[yKey] && Array.isArray(row[yKey])) {
            // Create an array of x,y points from the arrays
            var points = [];
            // Check that arrays have the same length
            var minLength = Math.min(row[xKey].length, row[yKey].length);
            // Skip points where both x and y are 0
            for (var i = 0; i < minLength; i++) {
                var x = row[xKey][i];
                var y = row[yKey][i];
                points.push({
                    name: "" + row.name,
                    tags: row.tags,
                    color: row.color,
                    colorTag: row.colorTag,
                    groups: row.groups,
                    x: x,
                    y: y
                });
            }
            // Return all points instead of just the first one
            if (points.length > 0) {
                return points;
            }
            // If we didn't build any points, return the pre-calculated x,y from the row
            if ('x' in row && 'y' in row) {
                return row;
            }
            return [];
        }
        // If it's a parent node or already has x,y properties, return as is
        return row;
    }).flat(); // Flatten the array to handle the multiple points per row
}
//# sourceMappingURL=scatter-plot.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/scatter-plot2/scatter-plot.chart.js